import React, { useState } from "react";
import { Calendar, ChevronDown } from "lucide-react";

const DateRangeFilter = ({ onChange }) => {
  const [activeRange, setActiveRange] = useState("Last 30 Days");
  const [isOpen, setIsOpen] = useState(false);

  const ranges = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "Last 90 Days",
    "This Year",
    "All Time"
  ];

  const handleSelect = (range) => {
    setActiveRange(range);
    setIsOpen(false);
    if (onChange) onChange(range);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-xl text-sm font-bold text-slate-700 hover:bg-slate-50 transition-all shadow-sm"
      >
        <Calendar size={16} className="text-primary" />
        {activeRange}
        <ChevronDown size={14} className={`ml-1 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-2xl shadow-xl border border-slate-100 z-50 overflow-hidden animate-in fade-in zoom-in duration-200 origin-top-right">
          <div className="py-2">
            {ranges.map((range) => (
              <button
                key={range}
                onClick={() => handleSelect(range)}
                className={`w-full text-left px-4 py-2 text-sm transition-colors ${
                  activeRange === range
                    ? "bg-primary/10 text-primary font-bold"
                    : "text-slate-600 hover:bg-slate-50"
                }`}
              >
                {range}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DateRangeFilter;
